import { Injectable } from '@angular/core';

import { CatalogObject, CatalogObjectSelection, CatalogObjectTypes } from '@mirage-projects/cw-models';

/** Service to get track of the elements selected in the object browser */
@Injectable({ providedIn: 'root' })
export class ObjectBrowserSelectionService {
    private mapSelection!: Map<CatalogObjectTypes, CatalogObject[]>;

    constructor() {
        this.resetSelection();
    }

    resetSelection(): void {
        this.mapSelection = new Map<CatalogObjectTypes, CatalogObject[]>();
        this.mapSelection.set('layers', []);
        this.mapSelection.set('projects', []);
        this.mapSelection.set('sites', []);
    }

    toggleSelection(element: CatalogObjectSelection | undefined, type: CatalogObjectTypes): void {
        if (!element) {
            return;
        }

        if (element.selected) {
            this.select(element.catalogObject, type);
        } else {
            this.unselect(element.catalogObject, type);
        }
    }

    select(element: CatalogObject, type: CatalogObjectTypes): void {
        if (!this.isElementSelected(element, type)) {
            this.mapSelection.get(type)?.push(element);
        }
    }

    unselect(element: CatalogObject, type: CatalogObjectTypes): void {
        const foundElementIndex: number = this.indexOfElementInSelection(element, type);

        if (foundElementIndex !== -1) {
            this.mapSelection.get(type)?.splice(foundElementIndex, 1);
        }
    }

    isElementSelected(element: CatalogObject, type: CatalogObjectTypes): boolean {
        return this.mapSelection.get(type)?.some((item: CatalogObject) => element.id === item.id) ?? false;
    }

    indexOfElementInSelection(element: CatalogObject, type: CatalogObjectTypes): number {
        return this.mapSelection.get(type)?.findIndex((item: CatalogObject) => element.id === item.id) ?? -1;
    }

    getNumberSelectedElements(): number {
        const layersCount: number = this.mapSelection.get('layers')?.length ?? 0;
        const projectsCount: number = this.mapSelection.get('projects')?.length ?? 0;
        const sitesCount: number = this.mapSelection.get('sites')?.length ?? 0;

        return Math.max(layersCount, projectsCount, sitesCount);
    }

    getSelectedElements(type: CatalogObjectTypes): CatalogObject[] | undefined {
        const values = this.mapSelection.get(type);

        return values ?? [];
    }

    getElementInSelectionById(id: number, type: CatalogObjectTypes): CatalogObject | undefined {
        return this.mapSelection.get(type)?.find((item: CatalogObject) => item.id === id);
    }
}
